/*=========================================================================================
  File Name: module-usertax-mutations.js
  Description: UserTax Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {};
